import { PlaceOutlined, SmartButton } from '@mui/icons-material'
import { Box, Grid, MenuItem, Typography, useTheme } from '@mui/material'

import useSharedStyles from '../../../utils/shared.styles'
import HighlightText from '../../highlight-text'
import useStyles from '../index.styles'

interface IResultDeviceItemProps {
  vanity: string
  nodeId: string
  folderName: string
  folderAddress: string
  isDeactivated: boolean
  searchValue: string
  onClick: () => void
}

const ResultDeviceItem = ({ vanity, nodeId, folderName, folderAddress, isDeactivated, searchValue, onClick }: IResultDeviceItemProps) => {
  const classes = useStyles
  const sharedClasses = useSharedStyles
  const theme = useTheme()

  return (
    <MenuItem onClick={onClick} tabIndex={0} data-testid="search-result-item">
      <Grid
        container={true}
        wrap="nowrap"
        sx={{
          alignItems: 'flex-start',
        }}
      >
        <SmartButton sx={classes.searchItemIcon} />
        <Box sx={classes.resultItemTextContainer}>
          <Typography variant="body1" className="fs-exclude" sx={sharedClasses.overflowText}>
            <HighlightText text={vanity} query={searchValue} colorHighlight={true} isDeactivated={isDeactivated} />
            <Typography variant="caption" sx={classes.searchItemPrimaryTextCaption}>
              • NodeID <HighlightText text={nodeId} query={searchValue} colorHighlight={true} />
            </Typography>
          </Typography>
          <Box sx={sharedClasses.overflowText}>
            {folderName && (
              <Typography variant="caption" className="fs-exclude" sx={sharedClasses.secondaryText}>
                <HighlightText text={folderName} query={searchValue} colorHighlight={true} />
              </Typography>
            )}
            {folderAddress && (
              <Typography variant="caption" className="fs-exclude" sx={sharedClasses.secondaryText}>
                <PlaceOutlined sx={{ ...classes.searchItemSecondaryTextIcon(theme), marginLeft: folderName ? 1 : 0 }} />
                <HighlightText text={folderAddress} query={searchValue} colorHighlight={true} />
              </Typography>
            )}
          </Box>
        </Box>
      </Grid>
    </MenuItem>
  )
}

export default ResultDeviceItem
